/**
 * Formats a number as Thai Baht currency
 * @param {number|string|null|undefined} value - The numeric value to format
 * @param {Object} options - Formatting options
 * @param {number} options.decimals - Number of decimal places (default: 0, rounds to integer)
 * @param {boolean} options.showSymbol - Whether to show currency symbol (default: true)
 * @param {string} options.fallback - Fallback value for invalid inputs (default: '-')
 * @returns {string} The formatted THB string or fallback if value is invalid
 */
export const THB = (value, options = {}) => {
    const { decimals = 0, showSymbol = true, fallback = '-' } = options;

    if (value == null || (typeof value === 'string' && value.trim() === '')) {
        return fallback;
    }

    const numericValue = typeof value === 'string' ? parseFloat(value) : value;

    if (!Number.isFinite(numericValue)) {
        return fallback;
    }

    const multiplier = 10 ** decimals;
    const formattedValue = Math.round(numericValue * multiplier) / multiplier;

    const formatter = new Intl.NumberFormat('th-TH', {
        style: 'decimal',
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
    });

    const formattedNumber = formatter.format(formattedValue);

    return showSymbol ? `฿${formattedNumber}` : formattedNumber;
};
